module.exports = __webpack_public_path__ + "static/media/no-data-concept-illustration_114360-536.5558d33b.jpg";